import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiPageHeaderButtonGroupComponent } from './fi-page-header-button-group.component';
import { MatMenuModule } from '@angular/material/menu';
import { FiAppTextSharedModule } from '../app-text';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [FiPageHeaderButtonGroupComponent],
    imports: [CommonModule, MatMenuModule, FiAppTextSharedModule, MatButtonModule, MatIconModule],
    exports: [FiPageHeaderButtonGroupComponent],
})
export class FiPageHeaderButtonGroupModule {}
